/**
 * @file
 * Fulbright front page listing (content grid).
 *
 * Initializes Masonry for the front page content grid.
 *
 * @author Ville Pesonen | Karhu Helsinki Oy <ville.pesonen@karhuhelsinki.fi>
 */

(function($) {
  var $listing_block = $("#block-content-grid-front");
  if ($listing_block.length) {
    // It is assumed news listing block uses Views Infinite Scroll.
    var $wrapper = $listing_block.find(".view-content-grid > .view-content");

    // Make sure Masonry is initialized after all the images have been loaded.
    // This is done by calling imagesLoaded-library first and initializing
    // Masonry in the callback.
    // First new item should appear different than the other (double-width). It
    // has been added the class 'highlight-item'. That item will be "stamped"
    // with Masonry and disregared from the grid items.
    // All the grid items are given extra class 'processed' in order to be able
    // to inform Masonry about appended grid items later on (Views AJAX-calls).
    $wrapper
      .imagesLoaded(function() {
        $("#block-content-grid-front")
          .find(".view-content-grid > .view-content")
          .masonry({
            horizontalOrder: true,
            itemSelector: ".grid-item",
            percentPosition: true,
            stamp: ".highlight-item",
            gutter: 30
          });
      })
      .find(".grid-item")
      .addClass("processed");

    // trigger on window load
    $( window ).on("load", function() {
      $wrapper
        .imagesLoaded(function() {
          $("#block-content-grid-front")
            .find(".view-content-grid > .view-content")
            .masonry({
              horizontalOrder: true,
              itemSelector: ".grid-item",
              percentPosition: true,
              stamp: ".highlight-item",
              gutter: 30
            });
        })
        .find(".grid-item")
        .addClass("processed");
    });
  }
})(jQuery);
